import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AbstractTabComponent } from '../../../common/abstracts/abstract-tab.component';
import { TabItem } from '../../../common/models/common.model';
import { Factory } from '../../production-inventory.model';
import { CompanyFactoryService } from '../../services/company-factory.service';

export enum InventoryTab {
  FACTORY_STOCK = 'factory-stock',
  FINISH_GOODS_STOCK = 'finish-goods-stock',
  TRANSFERS = 'transfers',
  FACTORY_STOCK_ADJUSTMENTS = 'factory-stock-adjustments',
  WAREHOUSE_STOCK_ADJUSTMENTS = 'warehouse-stock-adjustments',
}

@Component({
  selector: 'app-inventory-overview',
  standalone: false,
  templateUrl: './inventory-overview.component.html',
  styleUrl: './inventory-overview.component.scss',
})
export class InventoryOverviewComponent extends AbstractTabComponent implements OnInit {
  public override selectedTab: string = InventoryTab.FACTORY_STOCK;

  public override tabs: TabItem[] = [
    {
      label: 'Factory Stock',
      value: InventoryTab.FACTORY_STOCK,
      icon: 'bi bi-boxes',
      permissionCode: 'ui_inventory.factory_stock.view',
    },
    {
      label: 'Finish Goods Stock',
      value: InventoryTab.FINISH_GOODS_STOCK,
      icon: 'bi bi-archive',
      permissionCode: 'ui_inventory.finish_goods.view',
    },
    {
      label: 'Transfers',
      value: InventoryTab.TRANSFERS,
      icon: 'bi bi-arrow-left-right',
      permissionCode: 'ui_inventory.transfers.view',
    },
    {
      label: 'Factory Adjustments',
      value: InventoryTab.FACTORY_STOCK_ADJUSTMENTS,
      icon: 'bi bi-sliders',
      permissionCode: 'ui_inventory.factory_adjustments.view',
    },
    {
      label: 'Warehouse Adjustments',
      value: InventoryTab.WAREHOUSE_STOCK_ADJUSTMENTS,
      icon: 'bi bi-sliders',
      permissionCode: 'ui_inventory.warehouse_adjustments.view',
    },
  ];

  protected factories: Factory[] = [];
  protected isLoading = false;

  protected readonly InventoryTab = InventoryTab;

  constructor(
    private _companyFactoryService: CompanyFactoryService,
    protected override route: ActivatedRoute,
    protected override router: Router
  ) {
    super(route, router);
  }

  override ngOnInit(): void {
    // filterTabs() in the base class drops the tabs this designation cannot open, and
    // isValidTab then rejects a ?tab= deep link pointing at one of them.
    super.ngOnInit();
    this._loadFactories();
  }

  public override selectTab(tab: string): void {
    super.selectTab(tab);
  }

  private _loadFactories(): void {
    this.isLoading = true;
    this._companyFactoryService
      .listFactories()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (factories: Factory[]) => {
          this.factories = factories;
        },
      });
  }
}
